import { ModelType } from '~/services/api/ai/types';

const toOptions = (models: ModelType[] = []) =>
  models.map(model => ({ label: model.name, value: model.name }));

export default toOptions;
